import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './success.css';

const Success = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);
  
  const { planType, email } = location.state || {};

  useEffect(() => {
    // Save subscription info to localStorage
    if (planType && email) {
      localStorage.setItem('userSubscription', JSON.stringify({
        planType,
        email,
        startDate: new Date().toISOString(),
        isActive: true
      }));
    }

    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/chat');
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate, planType, email]);

  return (
    <div className="success-container">
      <div className="success-card">
        <div className="success-icon">✓</div>
        <h1>Payment Successful!</h1>
        <p>Thank you for subscribing to our {planType} plan.</p>
        <p>A confirmation email has been sent to {email}</p>
        <div className="redirect-message">
          Redirecting to chat in {countdown} seconds...
        </div>
        <button 
          className="chat-button"
          onClick={() => navigate('/chat')}
        >
          Go to Chat Now
        </button>
      </div>
    </div>
  );
};

export default Success; 